module.exports = __webpack_public_path__ + "media/images/flextab_devices-520x640-4d9241f8ce39923f848e599fc964bd2e.png";